export const projects = [
  { 
    id: 7, 
    sector: "Hospitality", 
    title: "The Ritz-Carlton", 
    location: "", 
    badge: "The #1 most anticipated new hotel opening of 2025",
    desc: "The installation serves as a visual anchor that culture, enhancing guests' spatial experience while echoing the hotel's design narrative of 'Flows and Glows'",
    fullDesc: "The installation serves as a visual anchor that culture, enhancing guests' spatial experience while echoing the hotel's design narrative of 'Flows and Glows'",
    images: [
        "/projects/Ritz Carton/mise en avant/71.webp"
    ],
    productionImages: [
        "/projects/Ritz Carton/production/1.webp",
        "/projects/Ritz Carton/production/2.webp",
        "/projects/Ritz Carton/production/3.webp",
        "/projects/Ritz Carton/production/4.webp",
        "/projects/Ritz Carton/production/5.webp",
        "/projects/Ritz Carton/production/6.webp"
    ],
    installationImages: [
        "/projects/Ritz Carton/complete/49.webp",
        "/projects/Ritz Carton/complete/51.webp",
        "/projects/Ritz Carton/complete/56.webp",
        "/projects/Ritz Carton/complete/57.webp",
        "/projects/Ritz Carton/complete/61.webp",
        "/projects/Ritz Carton/complete/62.webp",
        "/projects/Ritz Carton/complete/64.webp",
        "/projects/Ritz Carton/complete/65.webp",
        "/projects/Ritz Carton/complete/72.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: 6, 
    sector: "Hospitality", 
    title: "Yingjia Jinling Grand Hotel", 
    location: "", 
    desc: "We produced a collection of large-scale art installations for the Yingjia Jinling Grand Hotel, prominently featured in its lobby, public corridors, and event spaces",
    fullDesc: "We produced a collection of large-scale art installations for the Yingjia Jinling Grand Hotel, prominently featured in its lobby, public corridors, and event spaces",
    images: [
        "/projects/Yingjia Jinling Grand Hotel Anhui/mise en avant/1.webp"
    ],
    productionImages: [
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/1.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/11.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/15.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/17.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/25.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/7.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/production/8.webp"
    ],
    installationImages: [
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/1.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/10.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/11.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/12.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/13.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/14.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/15.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/16.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/17.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/2.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/3.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/4.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/5.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/6.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/7.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/8.webp",
        "/projects/Yingjia Jinling Grand Hotel Anhui/complete/9.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "crowne-plaza", 
    sector: "Hospitality", 
    title: "Crowne Plaza Hotel", 
    location: "", 
    desc: "The installations not only enhance the hotel's visual identity but also create immersive experiences that connect guests with the unique spirit of the seaside city",
    fullDesc: "The installations not only enhance the hotel's visual identity but also create immersive experiences that connect guests with the unique spirit of the seaside city",
    images: [
      "/images/hero 2.webp"
    ],
    projectDetailsImages: [
      "/projects/Crowne Plaza/Project details/微信图片_20260411212355_152_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212357_153_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212358_154_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212359_155_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212400_156_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212401_157_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212403_158_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212404_159_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212405_160_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212522_162_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212524_163_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212525_164_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212527_165_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212529_166_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212532_168_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212533_169_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212633_170_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212635_171_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212636_172_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212637_173_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212638_174_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212639_175_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212641_176_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212642_177_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212643_178_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212754_179_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212755_180_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212756_181_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212757_182_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212759_183_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212800_184_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212802_185_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212803_186_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212804_187_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212929_188_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212931_189_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212932_190_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212934_191_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212935_192_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212936_193_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212937_194_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212938_195_646.webp",
      "/projects/Crowne Plaza/Project details/微信图片_20260411212939_196_646.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "huafa-marriott-hotel", 
    sector: "Hospitality", 
    title: "Huafa Marriott Hotel", 
    location: "", 
    desc: "We produced a series of artworks for the guest rooms and public areas of the Zhuhai Huafa Marriott Hotel, drawing on the city's coastal and island heritage",
    fullDesc: "We produced a series of artworks for the guest rooms and public areas of the Zhuhai Huafa Marriott Hotel, drawing on the city's coastal and island heritage",
    contactCta: true,
    images: [
      "/projects/Huafa Marriott Hotel/Huafa Marriott Hotel.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "intercontinental-hotel-wuxi", 
    sector: "Hospitality", 
    title: "InterContinental Hotel", 
    location: "", 
    desc: "We produced a curated collection of artworks for the guest rooms and public spaces of the InterContinental Wuxi, thoughtfully placed to enhance the hotel's overall ambience",
    fullDesc: "We produced a curated collection of artworks for the guest rooms and public spaces of the InterContinental Wuxi, thoughtfully placed to enhance the hotel's overall ambience",
    contactCta: true,
    images: [
      "/projects/InterContinental Hotel Wuxi/InterContinental Hotel Wuxi.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "intercontinental-lake-hotel", 
    sector: "Hospitality", 
    title: "InterContinental Lake Hotel", 
    location: "", 
    desc: "Together, they enrich the hotel's serene, island-resort atmosphere, offering guests an immersive visual journey that echoes the poetic spirit of Dishui Lake and the elegance of a modern urban \"peach blossom haven\"",
    fullDesc: "Together, they enrich the hotel's serene, island-resort atmosphere, offering guests an immersive visual journey that echoes the poetic spirit of Dishui Lake and the elegance of a modern urban \"peach blossom haven\"",
    contactCta: true,
    images: [
      "/projects/InterContinental Lake Hotel/InterContinental Lake Hotel.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "vanke-palm-lake-villa", 
    sector: "Residential", 
    title: "Vanke Palm Lake Villa", 
    location: "", 
    desc: "Nestled on a peninsula embraced by the 110,000 m² Palm Lake in Shanghai's Anting New Town, this villa project extends along 3,000 meters of shoreline, with buildings oriented to capture both lake views and natural light",
    fullDesc: "Nestled on a peninsula embraced by the 110,000 m² Palm Lake in Shanghai's Anting New Town, this villa project extends along 3,000 meters of shoreline, with buildings oriented to capture both lake views and natural light",
    contactCta: true,
    images: [
      "/projects/Vanke Palm Lake Villa/Vanke Palm Lake Villa.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "wenzhou-jiameihu-millennium-hotel", 
    sector: "Hospitality", 
    title: "Jiameihu Millennium Hotel", 
    location: "", 
    desc: "Drawing from the resort's \"Source\" design concept, our pieces reinterpret Wencheng's natural scenery and cultural heritage - from the Baizhangji waterfall to traditional woodblock printing - through contemporary materials and forms",
    fullDesc: "Drawing from the resort's \"Source\" design concept, our pieces reinterpret Wencheng's natural scenery and cultural heritage - from the Baizhangji waterfall to traditional woodblock printing - through contemporary materials and forms",
    contactCta: true,
    images: [
      "/projects/Wenzhou Jiameihu Millennium Hotel/Wenzhou Jiameihu Millennium Hotel.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  },
  { 
    id: "xian-joy-city-future-city-art-gallery", 
    sector: "Public Spaces", 
    title: "Joy City Future City Art Gallery", 
    location: "", 
    desc: "Inspired by Malevich's geometric abstraction, the architecture integrates interiors and landscape through extension and superposition, creating a floating, timeless spatial experience",
    fullDesc: "Inspired by Malevich's geometric abstraction, the architecture integrates interiors and landscape through extension and superposition, creating a floating, timeless spatial experience",
    contactCta: true,
    images: [
      "/projects/Xi'an Joy City Future City Art Gallery/Xi'an Joy City Future City Art Gallery.webp"
    ],
    stats: {
      pieces: "TBD",
      duration: "TBD",
      materials: "Mixed Media"
    }
  }
];
